import { css, type Theme } from "@emotion/react";

export const tile = (theme: Theme) => css`
  height: auto;
  margin-bottom: ${theme.ds5.spacing.gap.small};
`;
